import { render } from "./RequirementsView.vue?vue&type=template&id=6d4e8d59&ts=true"
import script from "./RequirementsView.vue?vue&type=script&lang=ts"
export * from "./RequirementsView.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/paul/Documents/JetBrains/PhpstormProjects/AzuriomInstaller/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__